import React from 'react';
import { homeDark, documentsDark, taskDark, chatDark, contactsDark, rBlueIcon } from '../../static/svgs';

export default function SupportIcon({ section = 'support' }) {
  const existing = { home: homeDark, documents: documentsDark, tasks: taskDark, chat: chatDark, profile: contactsDark, version: rBlueIcon };
  if (existing[section]) return existing[section];
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#282932" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {section === 'messages' || section === 'support' ? <><path d="M4 14v-3a8 8 0 0 1 16 0v3M20 16v2a3 3 0 0 1-3 3h-3" /><rect x="2" y="11" width="4" height="7" rx="2" /><rect x="18" y="11" width="4" height="7" rx="2" /></> :
      section === 'suggestions' ? <><path d="M9 18h6M10 21h4M8.5 15.5a6 6 0 1 1 7 0L15 18H9z" /></> :
      section === 'start' ? <><rect x="3" y="4" width="18" height="16" rx="3" /><path d="m10 8 6 4-6 4z" /></> :
      <><circle cx="12" cy="12" r="9" /><path d="M12 11v6M12 7h.01" /></>}
  </svg>;
}
